function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.2h30v21.6H0V4.2Z",
    style: {
      fill: "#02529c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.2 25.8 8.4 25.8 8.4 17.4 0 17.4 0 12.6 8.4 12.6 8.4 4.2 13.2 4.2 13.2 12.6 30 12.6 30 17.4 13.2 17.4 13.2 25.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12 25.8 9.6 25.8 9.6 16.2 0 16.2 0 13.8 9.6 13.8 9.6 4.2 12 4.2 12 13.8 30 13.8 30 16.2 12 16.2 12 25.8",
    style: {
      fill: "#dc1e35"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIs);
export default __webpack_public_path__ + "static/media/IS.200e8ca62e76fd522d6fcf9b46f77fff.svg";
export { ForwardRef as ReactComponent };